import React, { useState, useEffect } from 'react';
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import './_style.scss';
import moment from 'moment';

const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;

const Guide = () => {


    useEffect(() => {
        if (localStorage.getItem("yongin_chat_guide") === undefined
            || localStorage.getItem("yongin_chat_guide") !== 'true') {
            document.getElementById('guide').style.visibility = 'visible'
        }
    }, []);

  const closeGuide = viewBool => {
    window.document.getElementById('guide').style.visibility = 'hidden';
    if (viewBool) {
      localStorage.setItem('yongin_chat_guide', true);
    }
  };

  return (
    <div className="guide" id="guide" style={{visibility: 'hidden'}}>
      <div className="guide_header">
        <div className="guide_header_button" onClick={() => closeGuide(true)}>
          다시보지 않기
        </div>
        <div className="guide_header_button" onClick={() => closeGuide(false)}>
          닫기
        </div>
      </div>

      <div className="guide_content">
        <CarouselProvider
          naturalSlideWidth="100vw"
          naturalSlideHeight={100}
          totalSlides={4}
        >
          <Slider>
            <Slide index={0}>
              <div style=
                {{
                  width: '100vw',
                  height: '100vh',
                  textAlign: 'center',
               }}>
                    <div className='guide_title' style={{color: 'white'}}>챗봇 활용팁</div>
                    <div className='guide_sub' style={{color: 'white'}}>
                        챗봇 사용은 처음이신가요?
                        <br/>
                        챗봇과 더 쉽게 대화하는 방법을 알려드릴게요!
                    </div>
                    <img style={{height: '60vh', width: 'auto'}} className='img_help' src={`/${domainUrlParam}/ibricks/images/guide_03.png`}
                            alt=""/>
              </div>
            </Slide>
            <Slide index={1} style={{width: "100vw"}}>
                <div style={{
                    width: "100vw",
                    height: "100vh",
                    textAlign: "center"
                }}>
                    <div className="guide_title" style={{color: "white"}}>만족도 평가</div>
                    <div className="guide_sub" style={{color: "white"}}>
                        더욱 똑똑한 &apos;조아용&apos;으로 성장할 수 있도록
                        <br />
                        많은 관심과 의견 보내주세요!
                    </div>
                    <img style={{height: "60vh", width: "auto"}} className="img_help" src={`/${domainUrlParam}/ibricks/images/guide_04.png`}
                            alt=""/>
                </div>
            </Slide>
            <Slide index={2} style={{width: "100vw"}}>
                <div style={{
                    width: "100vw",
                    height: "100vh",
                    textAlign: "center"
                }}>
                    <img style={{height: "80vh", width: "auto", marginTop: "0px"}} className="img_help" src={`/${domainUrlParam}/ibricks/images/help_03.png`} alt=""/>
                </div>
            </Slide>
            <Slide index={3} style={{width: "100vw"}}>
                <div style={{
                    width: "100vw",
                    height: "100vh",
                    textAlign: "center"
                }}>
                    <img style={{height: "80vh", width: "auto", marginTop: "0px"}} className="img_help" src={`/${domainUrlParam}/ibricks/images/help_04.png`} alt=""/>
                </div>
            </Slide>
          </Slider>

                <ButtonBack className="guide_back_button">
                    <i className="ri-arrow-left-circle-fill" />
                </ButtonBack>
                <ButtonNext className="guide_next_button">
                    <i className="ri-arrow-right-circle-fill" />
                </ButtonNext>
            </CarouselProvider>
        </div>
    </div>
  );
};

export default Guide;
